import React, { useCallback, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import logo from "../../image/ayekart logo.png";
import Loader from "../Loader";
import axios from "axios";
import { Box, ListItemIcon, Popover } from "@mui/material";
import "./FinanceGridView.css";
import axisBankLogo from "../../image/axis-logo.png";
import IciciODLogo from "../../image/ICICIOD.png";
import iciciBankLogo from "../../image/icici_bank_logo1.png";
import iciciH2H from "../../Assets/Images/Group 151.png";
import axish2h from "../../Assets/Images/axis-h2h.png";
import rblLogo from "../../Assets/Images/rbl-bank-logo.png";
import sbiLogo from "../../image/sbi-logo.png";
import { width } from "@mui/system";
import moment from "moment";
import { Button, Modal, Typography } from "@material-ui/core";
import { restrictedUser } from "../../utils";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

function FinanceGridView() {
  const location = useLocation();
  const params = useParams();
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [loading, setLoading] = useState(false);
  const [gridOrders, setGridOrders] = useState([]);
  const [markAsPaid, setMarkAsPaid] = useState(false);
  const [paidSubmitFlag, setPaidSubmitFlag] = useState(false);
  const [toGetUpdatedList, setTogetUpdatedList] = useState(false);
  const [status, setStatus] = useState("");
  const [workflowApprovalStatus, setWorkflowApprovalStatus] = useState("");
  const [allOrdersTotal, setAllOrdersTotal] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [statusArray, setStatusArray] = useState([]);
  const [formObj, setFormObj] = useState([]);
  const [selectedOrdersTotal, setSelectedOrdersTotal] = useState(0);
  const [downloadSheetFlag, setDownloadSheetFlag] = useState(false);
  const [dateForPaid, setDateForPaid] = useState();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const todaysDate = new Date()?.toISOString();
  const [openModal, setOpenModal] = React.useState(false);
  const [modalMessage, setModalMessage] = React.useState("");
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const history = useNavigate();
  const isAgro = location?.state?.org_id === 1;
  const isRetail = location?.state?.org_id === 2;
  const isFintech = location?.state?.org_id === 3;

  // useEffect(() => {
  //   if (userDetails?.user_category !== "Finance") {
  //     toast.error("Access denied");
  //     return history("/bulkorder");
  //   }
  // }, []);
  //-------------------------------------------------

  const getFinanceBankUrl = useCallback(
    (bank) => {
      const gridId = location?.state?.id
        ? location?.state?.id
        : location?.state;
      let org = isAgro
        ? "finance_agro"
        : isRetail
        ? "finance_retail"
        : "finance";

      return `/workflow/api/${gridId}/${org}?bank=${bank}`;
    },
    [isAgro, isFintech, isRetail, location]
  );

  const getPrefixForFileName = useCallback(
    () => (isAgro ? "AGRO" : isRetail ? "RETAIL" : "FINTECH"),
    [isAgro, isFintech, isRetail]
  );

  const getTableData = () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    fetch(
      `/workflow/api/${
        location?.state?.id ? location?.state?.id : location?.state
      }/orders`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res?.grid_status === "Paid") {
          setDownloadSheetFlag(true);
        }
        let temp = [];
        let sum = 0;
        res?.orders.map((item, index) => {
          if (item?.grid_status === "Paid") {
            setDownloadSheetFlag(true);
          }
          if (!isNaN(item?.amount_to_be_paid_net_off_tds)) {
            sum = sum + Number(item?.amount_to_be_paid_net_off_tds);
          }
          temp.push({
            order_id: item?.order_id,
            order_flag: item?.grid_status === "Paid" ? true : false,
          });
        });
        setStatusArray(temp);
        setAllOrdersTotal(sum);
        let tempAmount_PaidObj = res?.orders?.map((item, ind) => {
          return {
            ...item,
            amount_paid: item?.total_payable,
          };
        });

        setGridOrders(tempAmount_PaidObj);
        setStatus(res?.grid_status);
        setWorkflowApprovalStatus(res?.workflow_approval_status);
        if (res?.grid_status === "Paid") {
          setSelectedOrdersTotal(sum);
        }
        setLoading(false);
      });
  };
  useEffect(() => {
    getTableData();
  }, [toGetUpdatedList]);

  const onchangeHandlerForAmount = (e, ele, ind) => {
    let temp = gridOrders;
    let a = temp?.map((item, index) => {
      if (ind === index) {
        return {
          ...item,
          amount_paid: e.target.value,
        };
      }
    });
    setGridOrders(a);
  };

  const submitMarkAsPaid = () => {
    setIsSubmitDisabled(true);
    let temp = statusArray;
    let tempArray = [];
    temp.map((item, index) => {
      if (item?.order_flag === true) {
        tempArray.push(item?.order_id);
      }
    });

    let finalTemp = [];
    gridOrders.map((item, index) => {
      if (tempArray.includes(item?.order_id)) {
        console.log(item);
        const checkbox = document.getElementById(`checkbox-${index}`);

        if (checkbox.checked && !checkbox.disabled) {
          finalTemp.push({
            id: item?.order_id,
            amount_paid: item?.amount_paid,
            total_cp: item?.total_payable_net_off_tds,
            date: dateForPaid,
          });
        }
      }
    });

    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const payload = {
      orders: finalTemp,
      grid_status:
        gridOrders?.length === finalTemp?.length ? "Paid" : "Pending",
      actioner: userDetails?.user_name
        ? userDetails?.user_name
        : userDetails?.user_category,
    };

    if (dateForPaid <= todaysDate) {
      setLoading(true);
      setIsSubmitDisabled(false);
      axios
        .put(
          `/workflow/api/grid/${
            location?.state?.id ? location?.state?.id : location?.state
          }/paid`,
          payload,
          config
        )
        .then((data) => {
          if (!data?.data?.status) {
            setLoading(false);
            toast.error(data?.data?.message);
            setPaidSubmitFlag(true);
          } else {
            setTogetUpdatedList(true);
            setPaidSubmitFlag(true);
            toast.success(data?.data?.message);
            setTimeout(function () {
              history("/ayekart-fintech/grids",{
                state: { activeTab: 2 },
              });
            }, 1000);
          }
          setPaidSubmitFlag(false);
        });
    } else {
      setIsSubmitDisabled(false);
      if (dateForPaid > todaysDate)
        toast.error("Date should not be future date");
      if (!dateForPaid) {
        toast.error("Plese select date");
      }
    }
  };

  const currentDate = new Date()?.toISOString();
  const cancelGrid = () => {
    if (window.confirm("Do you really want to cancel this Grid?")) {
      setLoading(true);
      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      // Create an array with all the required fields
      const cancelGridOrders = gridOrders.map((item) => ({
        id: item?.order_id,
        amount_paid: item?.amount_paid,
        total_cp: item?.total_payable_net_off_tds,
        date: dateForPaid,
      }));

      const payload = {
        orders: cancelGridOrders,
        grid_status: "Rejected",
        rejection_stamp: `${currentDate}`,
        actioner: userDetails?.user_name
          ? userDetails?.user_name
          : userDetails?.user_category,
        actioner_id: userDetails?.id ? userDetails?.id : userDetails?.id,
      };
      axios
        .put(
          `/workflow/api/grid/${
            location?.state?.id ? location?.state?.id : location?.state
          }/paid`,
          payload,
          config
        )
        .then((data) => {
          if (!data?.data?.status) {
            setLoading(false);
            toast.error(data?.data?.message);
          } else {
            toast.success("Grid has been cancelled");
            setTimeout(function () {
              history("/ayekart-fintech/grids",{
                state: { activeTab: 3 },
              });
            }, 1000);
          }
        });
    }
  };

  // const getCSVForSBI = () => {
  //   const token = localStorage.getItem("token");
  //   const config = {
  //     headers: { Authorization: `Bearer ${token}` },
  //   };
  //   let temp = statusArray;
  //   let tempArray = [];
  //   temp.forEach((item, index) => {
  //     if (item?.order_flag === true && item?.grid_status !== "Paid") {
  //       const checkbox = document.getElementById(`checkbox-${index}`);
  //       if (checkbox.checked && !checkbox.disabled) {
  //         tempArray.push(item?.order_id);
  //       }
  //     }
  //   });
  //   const payload = {
  //     orders_id: tempArray,
  //   };
  //   axios
  //     .put(
  //       `/workflow/api/${
  //         location?.state?.id ? location?.state?.id : location?.state
  //       }/finance?bank=sbi`,
  //       payload,
  //       {
  //         responseType: "arraybuffer",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       const type = response.headers["content-type"];
  //       const blob = new Blob([response.data], {
  //         type: type,
  //         encoding: "UTF-8",
  //       });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `SBI_${moment(new Date()).format("DD-MM-YYYY")}_Grid-${
  //         location?.state?.id ? location?.state?.id : location?.state
  //       }.xlsx`;
  //       link.click();
  //     });
  // };

  const getCSVForIcici = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true && item?.grid_status !== "Paid") {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
    };
    const url = getFinanceBankUrl("icici");
    axios
      .put(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${getPrefixForFileName()}_ICICI_${moment(
          new Date()
        ).format("DD-MM-YYYY")}_Grid-${
          location?.state?.id ? location?.state?.id : location?.state
        }.xlsx`;
        link.click();
      });
  };

  const getCSVForRbl = () => {
    const token = localStorage.getItem("token");
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true && item?.grid_status !== "Paid") {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
    };
    const url = getFinanceBankUrl("rbl");
    axios
      .put(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${getPrefixForFileName()}_RBL_${moment(
          new Date()
        ).format("DD-MM-YYYY")}_Grid-${
          location?.state?.id ? location?.state?.id : location?.state
        }.xlsx`;
        link.click();
      });
  };

  const getCSVForAxis = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true && item?.grid_status !== "Paid") {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
    };
    const url = getFinanceBankUrl("axis");
    axios
      .put(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${getPrefixForFileName()}_AXIS_${moment(
          new Date()
        ).format("DD-MM-YYYY")}_Grid-${
          location?.state?.id ? location?.state?.id : location?.state
        }.xlsx`;
        link.click();
      });
  };

  const getCSVForICICIOD = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true && item?.grid_status !== "Paid") {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
    };
    const url = getFinanceBankUrl("icici_od");
    axios
      .put(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${getPrefixForFileName()}_ICICIOD_${moment(
          new Date()
        ).format("DD-MM-YYYY")}_Grid-${
          location?.state?.id ? location?.state?.id : location?.state
        }.xlsx`;
        link.click();
      });
  };

  const getForICICIH2H = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true && item?.grid_status !== "Paid") {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
      h2h_actioner: `${userDetails?.user_name}`,
    };
    setLoading(true);
    let url = "";
    if (isFintech) {
      url = `/api/finance/sheet/${
        location?.state?.id ? location?.state?.id : location?.state
      }?bank=icici`;
    } else if (isAgro) {
      url = `/workflow/api/finance/h2h_agro/${
        location?.state?.id ? location?.state?.id : location?.state
      }?bank=icici`;
    } else {
      // Exceptional case
      return;
    }
    axios
      .post(url, payload, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setLoading(false);
        setModalMessage(
          "The file has been successfully sent to ICICI host to host path. Kindly login to netbanking and authorize the payment. Once the payment is done please mark this payment as 'Paid'."
        );
        handleOpenModal();
        getTableData();
        setSelectAll(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something Went Wrong");
      });
  };

  const getForAxisH2H = () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    let temp = statusArray;
    let tempArray = [];
    temp.forEach((item, index) => {
      if (item?.order_flag === true && item?.grid_status !== "Paid") {
        const checkbox = document.getElementById(`checkbox-${index}`);
        if (checkbox.checked && !checkbox.disabled) {
          tempArray.push(item?.order_id);
        }
      }
    });
    const payload = {
      orders_id: tempArray,
      h2h_actioner: `${userDetails?.user_name}`,
    };
    setLoading(true);
    axios
      .post(
        `/axis/collections/axis/finance_sheet/${
          location?.state?.id ? location?.state?.id : location?.state
        }`,
        payload,
        {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        setModalMessage(
          "The file has been successfully sent to Axis host to host path. Kindly login to netbanking and authorize the payment. Once the payment is done please mark this payment as 'Paid'."
        );
        handleOpenModal();
        getTableData();
        setSelectAll(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Something Went Wrong");
      });
  };

  const changeStatusInStatusArray = (e, ind) => {
    let temp = statusArray;
    temp.map((item, tempIndex) => {
      if (tempIndex === ind) {
        if (e.target.checked) {
          temp[tempIndex].order_flag = e.target.checked;
        } else {
          temp[tempIndex].order_flag = e.target.checked;
        }
      }
    });
    let tempTotal = 0;
    temp?.map((item, index) => {
      if (item?.order_flag === true) {
        tempTotal =
          tempTotal + Number(gridOrders[index].amount_to_be_paid_net_off_tds);
      }
    });
    setSelectedOrdersTotal(tempTotal);
    setStatusArray(temp);
    setDummy(e.target.checked);
  };

  const selectAllFun = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setSelectedOrdersTotal(allOrdersTotal);
      let temp = statusArray;
      temp.map((item, index) => {
        if (gridOrders[index]?.grid_status === "Paid") {
          temp[index].order_flag = false;
        } else {
          temp[index].order_flag = true;
        }
      });
      setStatusArray(temp);
    } else {
      let temp = statusArray;
      temp.map((item, index) => {
        temp[index].order_flag = false;
      });
      setStatusArray(temp);
      setSelectedOrdersTotal(0);
    }
  };
  return (
    <div className="flex">
      <div className="mt-3  ">
        <Loader loading={loading} />
        <div className="container-fluid ">
          <span
            className="text-primary fs-6 font-semibold"
            onClick={() => history("/ayekart-fintech/grids",{ state: {activeTab:location?.state?.activeTab} })}
            style={{ cursor: "pointer" }}
          >
            {`<< Back`}
          </span>
        </div>
        <div className="container-fluid mt-3 p-0">
          <div
            className="border rounded-md p-2"
            style={{ backgroundColor: "#fff" }}
          >
            <div className="row mx-0">
              <div className="col col-sm-12 col-md-12 col-lg-12 pt-2">
                <div className="row">
                  <span className="">
                    <h5 className="fw-bold">
                      Total CP : ₹ {Number(allOrdersTotal).toFixed(2)}{" "}
                    </h5>
                  </span>
                </div>
                <div className="row border-top pt-2 mt-2">
                  <div className="col">
                    <span>
                      {/* <h5>
                    <span className="fw-bold">Net Amount:₹</span>{" "}
                    {Number(selectedOrdersTotal).toFixed(2)}{" "}
                  </h5>{" "} */}
                    </span>
                    {/* <h5>Out Of {allOrdersTotal} ₹</h5> */}
                  </div>
                </div>
              </div>
              <div className="col col-sm-12 col-md-12 col-lg-12 p-2">
                <div className="container-fluid text-center mt-2">
                  <div className="row d-flex mx-0 justify-content-end mt-2 pb-0 mb-3">
                    <div className="col-12 text-left px-0">
                      <span className="mt-3 fs-5 font-semibold">
                        Grid No.
                        {location?.state?.id
                          ? location?.state?.id
                          : location?.state}{" "}
                        Orders
                      </span>
                    </div>
                  </div>

                  <div className="row mx-0 mt-2 py-2 mb-3">
                    {isRetail || isFintech ? (
                      <div className="col col-sm-12 col-md-6 col-lg-2 pl-0">
                        <button
                          className="btn border btn-outline-light shadow "
                          style={{ height: "50px" }}
                          onClick={() => getCSVForAxis()}
                        >
                          <img
                            src={axisBankLogo}
                            alt=""
                            className="img-fluid h-100"
                          />
                        </button>
                      </div>
                    ) : null}
                    {isAgro || isFintech || isRetail ? (
                      <div className="col col-sm-12 col-md-6 col-lg-2 pl-0">
                        {downloadSheetFlag === true ? (
                          <a
                          // href={`/workflow/api/${location?.state?.id ? location?.state?.id : location?.state}/finance?bank=icici`}
                          >
                            <button
                              className="btn border btn-outline-light shadow "
                              style={{ height: "50px" }}
                              onClick={() => getCSVForIcici()}
                            >
                              <img
                                src={iciciBankLogo}
                                alt=""
                                className="img-fluid h-100"
                              />
                            </button>
                          </a>
                        ) : (
                          <button
                            className="btn  btn-outline-light border shadow"
                            style={{ height: "50px" }}
                            onClick={() => getCSVForIcici()}
                          >
                            <img
                              src={iciciBankLogo}
                              alt=""
                              className="img-fluid h-100"
                            />
                          </button>
                        )}
                      </div>
                    ) : null}

                    {isFintech && (
                      <div className="col col-sm-12 col-md-6 col-lg-2 pl-0">
                        <button
                          className="btn border btn-outline-light shadow"
                          style={{ height: "50px" }}
                          onClick={() => getCSVForICICIOD()}
                        >
                          <img
                            src={IciciODLogo}
                            alt=""
                            style={{ height: "100%", width: "100%" }}
                            className="img-fluid h-100"
                          />
                        </button>
                      </div>
                    )}
                    {location?.search === "?activeTab=approved" &&
                    (isFintech || isAgro) ? (
                      <div className="col col-sm-12 col-md-6 col-lg-2 pl-0 ">
                        <button
                          className="btn border btn-outline-light shadow "
                          style={{ height: "50px" }}
                          onClick={() => getForICICIH2H()}
                          disabled={restrictedUser()}
                        >
                          <img
                            src={iciciH2H}
                            alt=""
                            // style={{ height: "100%", width: "100%" }}
                            className="img-fluid h-100"
                          />
                        </button>
                      </div>
                    ) : null}

                    {location?.search === "?activeTab=approved" && isFintech ? (
                      <div className="col col-sm-12 col-md-6 col-lg-2 pl-0 ">
                        <button
                          className="btn border btn-outline-light shadow "
                          style={{ height: "50px" }}
                          onClick={() => getForAxisH2H()}
                          disabled={restrictedUser()}
                        >
                          <img
                            src={axish2h}
                            alt=""
                            className="img-fluid h-100"
                          />
                        </button>
                      </div>
                    ) : null}

                    {/* {isFintech || isRetail ? (
                      <div className="col col-sm-12 col-md-6 col-lg-2 pl-0 ">
                        <button
                          className="btn border btn-outline-light shadow "
                          style={{ height: "50px" }}
                          onClick={() => getCSVForRbl()}
                        >
                          <img
                            src={rblLogo}
                            alt=""
                            className="img-fluid h-100"
                          />
                        </button>
                      </div>
                    ) : null} */}
                  </div>

                  <div className="row finance-grid-table-head">
                    <div className="col col-sm-1 col-md-1 col-lg-1 pt-2 finance-grid-bg-adb2da d-flex">
                      <span className="w-25">
                        <input
                          type="checkbox"
                          className="form-check w-100"
                          checked={selectAll}
                          onChange={(e) => {
                            setDummy(e.target.checked);
                            selectAllFun(e);
                          }}
                          disabled={status === "Paid" ? true : false}
                        />
                      </span>
                      <h5>Order ID</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>Supplier Shop Name</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>Total CP(₹)</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>Total Payable(₹)</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>TDS(₹)</h5>
                    </div>
                    <div className="col col-sm-3 col-md-3 col-lg-3 pt-2 finance-grid-bg-adb2da">
                      <h5>Net Off TDS(₹)</h5>
                    </div>
                    {/* <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                  <span>
                    <h5>Amount Paid</h5>
                  </span>
                </div> */}
                  </div>
                  <div className="row mt-2 finance-grid-tbody">
                    <div className="container-fluid ">
                      {gridOrders?.length > 0 ? (
                        gridOrders?.map((item, index) => (
                          <React.Fragment key={index}>
                            <div className="row mb-2">
                              <div className="col col-sm-1 col-md-1 col-lg-1 pt-3 pb-2 finance-grid-bg-bec3ee d-flex">
                                <span className="w-25">
                                  <input
                                    type="checkbox"
                                    className="form-check w-100"
                                    id={`checkbox-${index}`}
                                    checked={statusArray[index]?.order_flag}
                                    disabled={
                                      item?.grid_status === "Paid"
                                        ? true
                                        : false
                                    }
                                    onChange={(e) => {
                                      changeStatusInStatusArray(e, index);
                                      setDummy(!dummy);
                                    }}
                                  />
                                </span>

                                <h6 className=" mt-1">
                                  {item?.order_id}{" "}
                                  {item?.h2h_flag && (
                                    <p
                                      style={{
                                        color: "Green",
                                        fontSize: "10px",
                                      }}
                                      className="fw-bolder"
                                    >
                                      Sent for H2H
                                    </p>
                                  )}
                                  {/* {item?.h2h_flag &&
                                location?.state?.l1_l2_flag ? (
                                  <p
                                    style={{ color: "Green", fontSize: "10px" }}
                                    className="fw-bolder"
                                  >
                                    Sent for H2H
                                  </p>
                                ) : (
                                  ""
                                )} */}
                                </h6>
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <h6 className=" mt-1">
                                  {item?.supplier_shop_name}
                                </h6>
                              </div>

                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  readOnly
                                  className="form-control"
                                  type="text"
                                  name=""
                                  value={
                                    isNaN(
                                      Number(item?.total_payable_net_off_tds)
                                    )
                                      ? (0.0).toFixed(2)
                                      : Number(
                                          item?.total_payable_net_off_tds
                                        ).toFixed(2)
                                  }
                                />
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  className="form-control"
                                  type="text"
                                  readOnly
                                  name=""
                                  value={
                                    isNaN(
                                      Number(item?.total_payable_net_off_tds)
                                    )
                                      ? (0.0).toFixed(2)
                                      : Number(
                                          item?.total_payable_net_off_tds
                                        ).toFixed(2)
                                  }
                                />
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  readOnly
                                  className="form-control"
                                  type="text"
                                  value={Number(item?.tds).toFixed(1)}
                                />
                              </div>
                              <div className="col col-sm-3 col-md-3 col-lg-3 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  readOnly
                                  className="form-control"
                                  type="text"
                                  name=""
                                  value={
                                    isNaN(
                                      Number(
                                        item?.amount_to_be_paid_net_off_tds
                                      )
                                    )
                                      ? (0.0).toFixed(2)
                                      : Number(
                                          item?.amount_to_be_paid_net_off_tds
                                        ).toFixed(2)
                                  }
                                />
                              </div>
                            </div>
                          </React.Fragment>
                        ))
                      ) : (
                        <>
                          <div className="row mt-2 finance-grid-tbody-no-data">
                            <p>No Data Added</p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2 pb-2">
                    {workflowApprovalStatus === "Approved" &&
                    userDetails?.user_category === "Finance" ? (
                      <div className="col d-flex mx-0 justify-content-center">
                        {true ? (
                          <>
                            <span className="fw" style={{ fontSize: "18px" }}>
                              Select Date :
                            </span>
                            <input
                              type="datetime-local"
                              className=" form-control ml-1 mr-3  h-75"
                              style={{ width: "12%" }}
                              onChange={(e) => {
                                console.log(
                                  new Date(e.target.value)?.toISOString()
                                );
                                setDateForPaid(
                                  new Date(e.target.value)?.toISOString()
                                );
                              }}
                            />
                            <span className="mr-1 ml-2">
                              <input
                                type="checkbox"
                                id="mark-payment"
                                className="form-check"
                                checked={markAsPaid}
                                onChange={(e) => {
                                  setMarkAsPaid(e.target.checked);
                                  setPaidSubmitFlag(e.target.checked);
                                }}
                                disabled={restrictedUser()}
                              />
                            </span>
                            <label
                              htmlFor="mark-payment"
                              role="button"
                              className="mr-3"
                            >
                              <h5 className="text-secondary">Mark as Paid</h5>
                            </label>
                            <button 
                              type="button"
                              className="btn btn-primary ayekart-fintech/grids-bg-4b589c mr-4 p-0 pl-3 pr-3 h-75"
                              // disabled={paidSubmitFlag ? false : true}
                              hidden={paidSubmitFlag ? false : true}
                              onClick={() => submitMarkAsPaid()}
                              disabled={isSubmitDisabled}
                            >
                              Submit
                            </button>
                          </>
                        ) : (
                          <></>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger mr-2 p-0 pl-3 pr-3 h-75 mb-2"
                          // disabled={markAsPaid ? false : true}
                          onClick={() => cancelGrid()}
                          disabled={restrictedUser()}
                        >
                          Cancel Grid
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Toaster />
      </div>
      {/* Modal to inform file sent to h2h path  */}
      <Modal
        className="rounded-md"
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="p"
            component="p"
            className="fw-bolder flex justify-start"
          >
            {modalMessage}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}></Typography>
          <div className="flex justify-end mt-2">
            <Button
              variant="contained"
              onClick={handleCloseModal}
              style={{ backgroundColor: "#B20D40", color: "#fff" }}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default FinanceGridView;
